import { useHistory } from 'react-router-dom-v5'
import { type Environment } from '../types/environment'

export const useFastpassMenuItems = (environment: Environment, code?: string, account?: string) => {
  const history = useHistory()
  return [
    {
      title: account || '',
      key: '',
      show: true,
      disabled: true,
    },
    {
      title: '我的訂單',
      key: '/order',
      show: true,
      children: [{
        title: '一般訂單',
        key: `/${environment === 'campaign' ? 'campaigns' : 'merchant'}/${code}/my-account/order`,
        show: true,
      }],
    },
    {
      title: '登出',
      key: '/logout',
      show: true,
      onClick: () => {
        if (environment === 'campaign') {
          history.push(`/campaigns/${code}/logout`)
        }
        else {
          history.push(`/merchant/${code}/logout`)
        }
      },
    },
  ]
}
